///封装axios
import axios from 'axios';
import router from '../router'
// 测试环境
// 生产环境
const service = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  	timeout: 20000000000,
})
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);
//请求拦截
service.interceptors.request.use(function(config) {
    //判断 token值是否为空
    if (localStorage.getItem("TOKEN")) {
        let auth = localStorage.getItem("TOKEN");
        config.headers["Authorization"] = `Bearer ${auth}`;
    }
    return config;
}, function(err) {
    //失败的话
    return Promise.reject(err);
});

//响应之后（响应拦截）
service.interceptors.response.use(function(data) {
    console.log(data.data.data.code, '响应之后（响应拦截）1111');
    if ( data.data.data.code == 200) {
		return data.data;
	} else {
		if (data.data.data.code == 999) {
			
			localStorage.removeItem("TOKEN");
            sessionStorage.removeItem("ms_user");
            localStorage.removeItem("MEMBER");
            Toast('账户过期，请重新登录');
      
			router.push('/member/login');
			return;
		}
		return data.data;
	}

}, function(err) {

    if (err.response.status) {
        switch (err.response.status) {
            case 404:
                // alert("请求的资源不存在");
                break;
            default:
                // alert("error");
                break;
        }
    }
    //失败的话
    return Promise.reject(err);

});

///封装get请求
export function get(url, params = {}) {
    console.log(params)
    console.log(url);
    return new Promise((resolve, reject) => {
        service({
            method: "get",
            url: url,
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

//封装delete
export function delet(url, params = {}) {
    return new Promise((resolve, reject) => {
        service({
            method: "delete",
            url: url,
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

//封装put请求
export function put(url, params = {}) {
    return new Promise((resolve, reject) => {
        service({
            method: "put",
            url: url,
            params
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });

    })
}

//封装post请求
export function post(url, data) {
    return new Promise((resolve, reject) => {
        //方式二
        service({
            method: "post",
            url: url,
            data: data
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
}

export default service;